import { render, staticRenderFns } from "./ListMessageHistoryModal.vue?vue&type=template&id=536b9c16"
import script from "./ListMessageHistoryModal.vue?vue&type=script&lang=js"
export * from "./ListMessageHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./ListMessageHistoryModal.vue?vue&type=style&index=0&id=536b9c16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports